import * as React from "react";
import cx from "classnames";

import { DatasheetItem } from '@modules/datasheets/components/datasheet-item';
import { MovableItem } from "../movable-item";
import { TextElementProps, useTextElementController } from "./text-element.controller";

import { TextArea } from "@common/components/text-area";
import { DatasheetComponentTextStyle } from "@common/dto/datasheet/component-settings/text-style";

import "./text-element.styles.scss";

export const TextElement: React.FC<TextElementProps> = React.memo((props) => {
  const { datasheetElement, multipleElementsSelected, isTabOrderSettingActive } = props;

  const {
    coordinates,
    datasheetElementSelected,
    handleDatasheetElementMouseDown,
    movableElementRef,
    handleResizing,
    size,
    handleTextChange
  } = useTextElementController(props);

  return (
    <DatasheetItem
      style={{
        top: coordinates.y,
        left: coordinates.x,
        display: "block",
      }}
    >
      <MovableItem
        resizing={{
          enabled: isTabOrderSettingActive ? false : !multipleElementsSelected,
          onChange: handleResizing,
        }}
        moving={{
          enabled: !isTabOrderSettingActive,
        }}
        reference={movableElementRef}
        height={size.height}
        width={size.width}
        selected={datasheetElementSelected}
        onMouseDown={isTabOrderSettingActive ? undefined : handleDatasheetElementMouseDown}
        className={cx("DatasheetsEditorDatasheetTextElement__movable-item", {
          ["DatasheetsEditorDatasheetTextElement__movable-item--empty"]: !datasheetElement.original.text.trim(),
          ["DatasheetsEditorDatasheetTextElement__movable-item--active"]: datasheetElementSelected,
        })}
      >
        <TextArea
          className={cx(
            "DatasheetsEditorDatasheetTextElement__textarea",
            { "DatasheetsEditorDatasheetTextElement__textarea--disabled": isTabOrderSettingActive }
          )}
          style={{
            width: size.width,
            fontSize: datasheetElement.original.fontsize,
            fontFamily: datasheetElement.original.fontname,
            color: datasheetElement.original.fontColor ? datasheetElement.original.fontColor.toString() : undefined,
            fontWeight: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.bold)
              ? 700
              : undefined,
            fontStyle: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.italic)
              ? "italic"
              : undefined,
            textDecoration: datasheetElement.original.textstyle.includes(DatasheetComponentTextStyle.underline)
              ? "underline"
              : undefined,
          }}
          value={datasheetElement.original.text}
          onChange={handleTextChange}
        />
      </MovableItem>
    </DatasheetItem>
  );
});
